import React from "react";
import { Link } from "react-router-dom";
import { formatINR } from "../lib/api";
import SafeImage from "./SafeImage";

export default function ProductCard({ product, index = 0 }) {
  const hasAlt = product.images.length > 1;
  const primary = product.images[0];
  const secondary = product.images[1] || product.images[0];

  return (
    <Link
      to={`/shop/${product.slug}`}
      className="group block lift-card"
      data-testid={`product-card-${product.slug}`}
      style={{ animationDelay: `${index * 40}ms` }}
    >
      <div className="relative overflow-hidden bg-[#b8af92] aspect-[3/4]">
        <SafeImage
          src={primary}
          alt={product.name}
          className="absolute inset-0 w-full h-full object-cover transition-all duration-[1400ms] ease-out group-hover:scale-110 group-hover:opacity-0"
          loading="lazy"
        />
        {hasAlt && (
          <SafeImage
            src={secondary}
            alt={`${product.name} alternate view`}
            className="absolute inset-0 w-full h-full object-cover scale-110 opacity-0 transition-all duration-[1400ms] ease-out group-hover:opacity-100 group-hover:scale-100"
            loading="lazy"
          />
        )}
        {product.is_new && (
          <span
            className="absolute top-4 left-4 bg-[#c3ba9e] text-[#1A1A1A] text-[10px] tracking-[0.28em] uppercase px-3 py-1 font-body"
            data-testid="product-badge-new"
          >
            New
          </span>
        )}
        {product.compare_at_price && (
          <span className="absolute top-4 right-4 bg-[#1A1A1A] text-[#c3ba9e] text-[10px] tracking-[0.28em] uppercase px-3 py-1 font-body">
            Sale
          </span>
        )}
        <div className="absolute bottom-0 left-0 right-0 translate-y-full group-hover:translate-y-0 transition-transform duration-500 ease-out bg-[#1A1A1A]/95 text-[#c3ba9e] text-center py-3 text-[11px] tracking-[0.28em] uppercase">
          View Piece
        </div>
      </div>
      <div className="pt-5 flex items-start justify-between gap-4">
        <div>
          <h3 className="font-serif-display text-xl leading-tight">
            {product.name}
          </h3>
          <p className="text-xs text-[#7A7A7A] mt-1 tracking-wider">
            {product.color} · {product.fabric}
          </p>
        </div>
        <div className="text-right shrink-0">
          <p className="font-body text-sm text-[#1A1A1A]">
            {formatINR(product.price)}
          </p>
          {product.compare_at_price && (
            <p className="font-body text-xs text-[#7A7A7A] line-through">
              {formatINR(product.compare_at_price)}
            </p>
          )}
        </div>
      </div>
    </Link>
  );
}
